import React from 'react';
import ContentLoader from 'react-content-loader';
function Rectangle({ width = 400, height = 200, background = '#f3f3f3', foreground = '#ecebeb', className, }) {
    const radius = (width > height ? height : width) / 4;
    return (React.createElement(ContentLoader, { speed: 2, width: width, height: height, viewBox: `0 0 ${width} ${height}`, backgroundColor: background, foregroundColor: foreground, className: className },
        React.createElement("rect", { x: "0", y: "0", rx: radius, ry: radius, width: width, height: height })));
}
function Circle({ size = 400, background = '#f3f3f3', foreground = '#ecebeb', className, }) {
    return (React.createElement(ContentLoader, { speed: 2, width: size, height: size, viewBox: `0 0 ${size} ${size}`, backgroundColor: background, foregroundColor: foreground, className: className },
        React.createElement("circle", { cx: size / 2, cy: size / 2, r: size / 2 })));
}
export default { Rectangle, Circle };
